/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Cooperationcontractbackon3Inputs */

const de__field_cooperationcontractbackon3 = /** @type {(inputs: _Field_Cooperationcontractbackon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rahmenvereinbarung zurückerhalten am`)
};

/**

* @param {_Field_Cooperationcontractbackon3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_cooperationcontractbackon3 = /** @type {((inputs?: _Field_Cooperationcontractbackon3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Cooperationcontractbackon3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_cooperationcontractbackon3(inputs)
});
export { _field_cooperationcontractbackon3 as "_field_cooperationContractBackOn" }